// extracted by mini-css-extract-plugin
export default {"Loading":"Loading_Loading__mLr+L","Arrow":"Loading_Arrow__a5EBY","WrapperLoading":"Loading_WrapperLoading__09ss9","right":"Loading_right__auHBj"};